module.exports = __webpack_public_path__ + "img/about-problem2.af5dd04b.png";